import {HTMLProps} from 'react';

interface IProps extends Omit<HTMLProps<HTMLDivElement>, 'ref'> {}

export default function FullWidth({className, ...rest}: IProps) {
  return (
    <div
      className={cn('w-screen lg:ml-[calc((100vw-630px)/-2)]', className)}
      {...rest}
    />
  );
}
